exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".single-column img:not(.no-margin){margin:20px 0}.single-column img{max-width:100%}.single-column .subcategory{-ms-flex-preferred-size:100%;flex-basis:100%}.double-column img:not(.no-margin){margin:20px 0}.double-column img{max-width:100%}.double-column .subcategory{flex-basis:50%;-ms-flex-preferred-size:47%}.double-column .subcategory img{max-width:100%}@media screen and (max-width:900px){.double-column,.single-column{padding-right:0}}.category-title h1{font-size:1.8rem;font-weight:400}@media screen and (min-width:480px){.category-title h1{font-size:2.5rem}}@media screen and (min-width:900px){.category-title h1{font-size:2.8rem}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/stylus-loader!./src/containers/categorycontainer/categorycontainer.styl
// module id = 516
// module chunks = 0